"use strict";

var _objectWithoutProperties = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _excluded = ["markerEnd", "pathPoints"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// Copyright (c) 2017 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var D_CMDS = ['M', 'C'];

// const strokeDefId = 'pathStroke';
// const strokeReference = `url(#${strokeDefId})`;

// export function EdgePathStrokeDef(props) {
//   const strokeDef = (
//     <linearGradient id={strokeDefId}>
//       <stop offset="0%" stopColor="#00c" />
//       <stop offset="7%" stopColor="#00c" />
//       <stop offset="93%" stopColor="#0c0" />
//       <stop offset="100%" stopColor="#0c0" />
//     </linearGradient>
//   );
//   return props.enclose ? <defs>{strokeDef}</defs> : strokeDef;
// }

// NOTE: This function is necessary for gradient stroke
// function renderPathPoint(pt, i) {
//   let [x, y] = pt;
//   if (i === 0) {
//     // add a small amount of jitter (1% of a pixel) to avert an issue with
//     // bounding-box based linear gradients
//     // https://stackoverflow.com/q/13223636/1888292
//     y += 0.01;
//   }
//   return `${D_CMDS[i] || ''}${x},${y}`;
// }
var EdgePath = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(EdgePath, _React$PureComponent);
  var _super = _createSuper(EdgePath);
  function EdgePath() {
    _classCallCheck(this, EdgePath);
    return _super.apply(this, arguments);
  }
  _createClass(EdgePath, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        markerEnd = _this$props.markerEnd,
        pathPoints = _this$props.pathPoints,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var d = pathPoints.map(function (pt, i) {
        return "".concat(D_CMDS[i] || '').concat(pt.join(','));
      }).join(' ');
      return /*#__PURE__*/React.createElement("path", Object.assign({
        d: d,
        fill: "none",
        stroke: "#000",
        vectorEffect: "non-scaling-stroke",
        markerEnd: markerEnd
      }, rest));
    }
  }]);
  return EdgePath;
}(React.PureComponent);
exports.default = EdgePath;